import { GROUPS_LIST_CONSTANTS } from './groupsList.constants';

export const mergeGroupsWithCache = (
  existingItems: EnrichedGroupList[],
  newItems: EnrichedGroupList[],
): EnrichedGroupList[] => {
  const existingIds = new Set(existingItems.map((item) => item.id));
  const uniqueNewItems = newItems.filter((item) => !existingIds.has(item.id));

  const merged = [...existingItems, ...uniqueNewItems];

  return merged.length > GROUPS_LIST_CONSTANTS.MAX_CACHED_ITEMS
    ? merged.slice(-GROUPS_LIST_CONSTANTS.MAX_CACHED_ITEMS)
    : merged;
};
